// extracted by mini-css-extract-plugin
export var modalFooter = "_r2-0";